import { mapState } from 'vuex';
import authServices from "@/services/AuthServices.js"
import Compressor from 'compressorjs';

export default {
    data () {
        return {
            books: [],
            isEdit: false,
            actualPart: {
                index: null,
                part: ''
            },
            allowableTypes: ['jpg', 'jpeg', 'png'],
            maximumSize: 1000000,
            tmpImages: [],
            isBooksView: false,
            isExercisesView: false,
            positionScroll: 0,
        }
    },
    computed: {
        ...mapState('appkonspektypilkanozna', ['config'])
    },
  methods: {
    endDrag() {
        this.session.introductory_part_1.data.forEach((elem, index) => {
          elem.id = index;
        })
        this.session.introductory_part_2.data.forEach((elem, index) => {
            elem.id = index;
          })
          this.session.main_part_1.data.forEach((elem, index) => {
            elem.id = index;
          })
          this.session.main_part_2.data.forEach((elem, index) => {
            elem.id = index;
          })
          this.session.final_part.data.forEach((elem, index) => {
            elem.id = index;
          })
      },
     togglePanel(show) {
        this.resetZoomed();
        this.isEdit = show;
    },
    previewImage(e) {
        this.$f7.toast.create({
            text: 'Remember! The recommended dimensions are 900x600',
            position: 'bottom',
            closeTimeout: 3000,
        }).open();
        if (!this.allowableTypes.includes(e.target.files[0].name.split('.').pop().toLowerCase())) {
            this.$f7.toast.create({
                text: 'Invalid file format. Acceptable file formats are: JPG, JPEG, PNG!',
                position: 'bottom',
                closeTimeout: 3000,
            }).open();
            return false
        }
        if (e.target.files[0].size > this.maximumSize) {
            this.$f7.toast.create({
                text: 'The file is too heavy. The maximum size of the file is: 1 MB!',
                position: 'bottom',
                closeTimeout: 3000,
            }).open();
            return false
        }
        const self = this
        if (e.target.files && e.target.files[0]) {
            new Compressor(e.target.files[0], {
                quality: 0.6,
                maxHeight: 600,
                maxWidth: 900,
            
                success(result) {
                  var reader = new FileReader();
                  reader.onload = (e) => {
                      const image = {
                        type: self.actualPart.part,
                        index: self.actualPart.index,
                        image: e.target.result,
                      }
                      self.tmpImages.push(image);
                      self.session[self.actualPart.part].data[self.actualPart.index].img = {
                          id: '',
                          graphics: e.target.result
                      }
                  }
                  reader.readAsDataURL(result);
                },
                error(err) {
                  console.log(err.message);
                },
              });
        }
    },
    removeExercise(index, id, type) {
        this.removeImageExercise(id, type);
        this.session[type].data.splice(index, 1);
    },
    removeImageExercise(id, type) {
        const findIndex = this.tmpImages.findIndex(obj => obj.type == type && obj.index == id)
        this.tmpImages.splice(findIndex, 1)

        this.session[type].data.find(elem => elem.id == id).img.id = '';
        this.session[type].data.find(elem => elem.id == id).img.graphics = '';
    },
    addExercise(type) {
        this.isEdit = false
        let maxId;
        if (this.session[type].data.length > 0) {
            maxId = this.session[type].data.reduce((p, c) => p.value > c.value ? p : c);
        }
        const exercise = {
            id: this.session[type].data.length > 0 ? maxId.id + 1 : 1,
            topic: '',
            description: '',
            img: {
                id: '',
                graphics: ''
            },
            mod: '',
            time: null
        }
        this.session[type].data.push(exercise);
    },
    setActualPart(index, part) {
        this.actualPart.index = index;
        this.actualPart.part = part;
    },
    addExerciseOnBooks(index, part) {
        this.isEdit = false
        this.isBooksView = true;
        this.setActualPart(index, part)
      },
      addPrivateExercise(index, part) {
        this.isEdit = false
        this.isExercisesView = true;
        this.setActualPart(index, part)
      },
    async fetchDataBooks() {
        try {
            this.loader = true;
            const responseDataBooks = await authServices.books('','');
            this.books = responseDataBooks.data
        } catch (error) {
            this.$f7.toast
            .create({
                text: "Something went wrong. Please try again or contact your administrator.",
                            position: "bottom",
            
                closeTimeout: 3000
            })
            .open();
            console.log(error);
        }
        this.loader = false;
        },
      moveExerciseToOutline(data) {
        this.session.type_copied = data.typeCopied
        this.session[this.actualPart.part].data[this.actualPart.index].topic = ''
        this.session[this.actualPart.part].data[this.actualPart.index].description = ''
        this.session[this.actualPart.part].data[this.actualPart.index].mod = ''
        this.session[this.actualPart.part].data[this.actualPart.index].img = {
            id: '',
            graphics: ''
        }
        this.isBooksView = false;
        this.isExercisesView = false;
        if (data.content && data.content.length > 0) {
            data.content.forEach((elem) => {
                const row = elem.replaceAll('<strong>', '').replaceAll('</strong>', '.')
                this.session[this.actualPart.part].data[this.actualPart.index].description += row + ' \n'
            });
        }
        if (data.mod && data.mod.length > 0) {
            data.mod.forEach((elem) => {
                this.session[this.actualPart.part].data[this.actualPart.index].mod += elem + ' \n'
            });
        }
        if (data.name) {
            this.session[this.actualPart.part].data[this.actualPart.index].topic = data.name
        }
        if (data.mainImage) {
            this.session[this.actualPart.part].data[this.actualPart.index].img = {
                id: 'onBooks',
                graphics: data.mainImage
            }
        }
        this.$nextTick(() => {
            this.autoResizeAllTextarea()
          });
      },
      moveExerciseToOutlineOnPrivateExercise(data) {
            console.log(data)
            this.session.type_copied = data.typeCopied
            this.session[this.actualPart.part].data[this.actualPart.index].topic = ''
            this.session[this.actualPart.part].data[this.actualPart.index].description = ''
            this.session[this.actualPart.part].data[this.actualPart.index].mod = ''
            this.session[this.actualPart.part].data[this.actualPart.index].img = {
                id: '',
                graphics: ''
            }
            this.isBooksView = false;
            this.isExercisesView = false;
            if (data.description) {
                this.session[this.actualPart.part].data[this.actualPart.index].description = data.description
            }
            if (data.mod) {
                this.session[this.actualPart.part].data[this.actualPart.index].mod = data.mod
            }
            if (data.topic) {
                this.session[this.actualPart.part].data[this.actualPart.index].topic = data.topic
            }
            if (data.mainImage) {
                this.session[this.actualPart.part].data[this.actualPart.index].img = {
                    id: data.img.id,
                    graphics: data.mainImage
                }
            }
            this.$nextTick(() => {
                this.autoResizeAllTextarea()
              });
      }
   }
}